module.exports = __webpack_public_path__ + "img/IMG_8907.4592c834.jpg";